import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStackChart = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.75 8.25C15.6507 8.46147 15.3414 8.61775 14.7227 8.9303L9.45139 11.5933C9.01088 11.8158 8.79062 11.9271 8.5596 11.9709C8.35498 12.0097 8.14501 12.0097 7.9404 11.9709C7.70938 11.9271 7.48911 11.8158 7.04862 11.5933L1.77729 8.9303C1.15861 8.61775 0.849267 8.46147 0.75 8.25M15.75 12C15.6507 12.2115 15.3414 12.3677 14.7227 12.6803L9.45138 15.3433C9.01088 15.5658 8.79062 15.6771 8.5596 15.7209C8.35498 15.7597 8.14501 15.7597 7.9404 15.7209C7.70937 15.6771 7.48912 15.5658 7.04861 15.3433L1.77729 12.6803C1.15861 12.3677 0.849267 12.2115 0.75 12M9.4411 7.87257L14.6673 5.4012C15.2807 5.11114 15.5873 4.96611 15.6858 4.76986C15.7714 4.59907 15.7714 4.40093 15.6858 4.23014C15.5873 4.03389 15.2807 3.88886 14.6673 3.5988L9.44109 1.12742C9.00436 0.920901 8.786 0.817639 8.55695 0.776997C8.35409 0.741001 8.14591 0.741001 7.94305 0.776997C7.714 0.817639 7.49564 0.920901 7.0589 1.12743L1.83273 3.5988C1.21934 3.88886 0.912651 4.03389 0.814234 4.23014C0.728589 4.40093 0.728589 4.59907 0.814234 4.76986C0.912651 4.96611 1.21934 5.11114 1.83273 5.4012L7.05891 7.87258C7.49564 8.0791 7.714 8.18236 7.94305 8.223C8.14591 8.259 8.35409 8.259 8.55695 8.223C8.786 8.18236 9.00436 8.0791 9.4411 7.87257Z",
		stroke: "#18181B",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgStackChart);
export default ForwardRef;
